<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-button-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">Error state</h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<div class="content">

    <h2>Error State Use Case in Bookshelf Course Level</h2>
    <maced-error-state [id]="id" [imageUrl]="imageUrl" [title]="title"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
                To add new course please visit Macmillan Education Everywhere <a [href]="linkUrl" [target]="linkTarget">{{linkLabel}}
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="16px" height="16px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
<path id="path-1_1_" d="M9.5,2H13c0.6,0,1,0.4,1,1v3.5c0,0.6-0.4,1-1,1s-1-0.4-1-1V5.4L9.7,7.7C9.5,7.9,9.3,8,9,8S8.5,7.9,8.3,7.7
	c-0.4-0.4-0.4-1,0-1.4L10.6,4H9.5c-0.6,0-1-0.4-1-1S8.9,2,9.5,2z M11,10c0-0.6,0.4-1,1-1s1,0.4,1,1v1c0,2.2-1.8,4-4,4H5
	c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h1c0.6,0,1,0.4,1,1S6.6,5,6,5H5C3.9,5,3,5.9,3,7v4c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2V10z"/>
</svg>

                </a>
        </ng-container>
    </maced-error-state>

    <h2>Error State Use Case in Downloads</h2>
    <maced-error-state [id]="id2" [imageUrl]="imageUrl2" [title]="title2"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
                You dont have any units downloaded
        </ng-container>

        <ng-container ngProjectAs="[content-footer]">
            <maced-button [styleClass]="buttonStyleClass" color="primary" [buttonId]="buttonId" [label]="buttonLabel" [type]="buttonType"
                [target]="buttonTarget" [url]="buttonUrl"></maced-button>
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case in Search Results</h2>
    <maced-error-state [id]="id3" [imageUrl]="imageUrl3" [title]="title3"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
                Enter another keyword to search 
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case in 502 Bad Gateway</h2>
    <maced-error-state [id]="id4" [imageUrl]="imageUrl4" [title]="title4" [errorMessage]="errorMessage4"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
                The server encountered a temporary error and was unable to complete your request
        </ng-container>
        <ng-container ngProjectAs="[content-footer]">
            <maced-button [styleClass]="buttonStyleClass4" color="primary" [buttonId]="buttonId4" [label]="buttonLabel4" [type]="buttonType4"
                [target]="buttonTarget4" [url]="buttonUrl4"></maced-button>
            <a routerLink="/card" class="u-link-primary">{{linkLabel4}}</a>
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case in 404 Page Not Found</h2>
    <maced-error-state [id]="id5" [imageUrl]="imageUrl5" [title]="title5" [errorMessage]="errorMessage5"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
                The server encountered a temporary error and was unable to complete your request
        </ng-container>
        <ng-container ngProjectAs="[content-footer]">
            <maced-button [styleClass]="buttonStyleClass5" color="primary" [buttonId]="buttonId5" [label]="buttonLabel5" [type]="buttonType5"
                [target]="buttonTarget5" [url]="buttonUrl5"></maced-button>
            <a routerLink="/card" class="u-link-primary">{{linkLabel5}}</a>
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case with Spanish Language</h2>
    <maced-error-state [id]="id7" [imageUrl]="imageUrl5" [title]="title7" [errorMessage]="errorMessage7"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
            El servidor encontró un error temporal y no pudo completar su solicitud
        </ng-container>
        <ng-container ngProjectAs="[content-footer]">
            <maced-button [styleClass]="buttonStyleClass7" color="primary" [buttonId]="buttonId7" [label]="buttonLabel7" [type]="buttonType7"
                [target]="buttonTarget7" [url]="buttonUrl7"></maced-button>
            <a routerLink="/card" class="u-link-primary">{{linkLabel7}}</a>
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case with Hindi Language</h2>
    <maced-error-state [id]="id8" [imageUrl]="imageUrl5" [title]="title8" [errorMessage]="errorMessage8"
        [ariaLabels]="ariaLabels" [imageWidthLarge]=285 [imageHeightLarge]=252>
        <ng-container ngProjectAs="[content-body]">
            सर्वर को एक अस्थायी त्रुटि का सामना करना पड़ा और वह आपका अनुरोध पूरा करने में असमर्थ था
        </ng-container>
        <ng-container ngProjectAs="[content-footer]">
            <maced-button [styleClass]="buttonStyleClass8" color="primary" [buttonId]="buttonId8" [label]="buttonLabel8" [type]="buttonType8"
                [target]="buttonTarget8" [url]="buttonUrl8"></maced-button>
            <a routerLink="/card" class="u-link-primary">{{linkLabel8}}</a>
        </ng-container>
    </maced-error-state>
    
    <h2>Error State Use Case Without content body and footer</h2>
    <maced-error-state [id]="id6" [imageUrl]="imageUrl3" [title]="title6" [errorMessage]="errorMessage6" [imageWidthLarge]=285 [imageHeightLarge]=252></maced-error-state>

</div>